// Copyright (c) 2026 Celadon Development LLC, All rights reserved.
// Author Vasily Klyuev <vasily.klyuev@celadon.ae>
import GlobalStyles from '../../../../config/styles';

// Every colour is explicit: an unset colour inherits white in this panel and
// the text disappears, which is what happened on the issue-voucher screen.
const styles = () => ({
  container: {
    width: '100%',
  },
  group: {
    width: '100%',
    marginBottom: 16,
    padding: 12,
    borderRadius: 8,
    border: '1px solid #E5E5E5',
  },
  groupHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    paddingBottom: 8,
    borderBottom: '1px solid #E5E5E5',
  },
  groupTitle: {
    margin: 0,
    flex: 1,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    color: GlobalStyles.color.COLOR_GREY,
    wordBreak: 'break-word',
  },
  groupValue: {
    margin: '0 0 0 12px',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    color: GlobalStyles.color.COLOR_GREY,
    whiteSpace: 'nowrap',
  },
  bookRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    marginTop: 8,
  },
  bookTitle: {
    margin: 0,
    flex: 1,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    color: GlobalStyles.color.COLOR_BLACK_GREY,
    wordBreak: 'break-word',
  },
  bookPrice: {
    margin: '0 0 0 12px',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    color: GlobalStyles.color.COLOR_BLACK_GREY,
    whiteSpace: 'nowrap',
  },
  groupFooter: {
    margin: '10px 0 0 0',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    color: GlobalStyles.color.COLOR_GRAY,
  },
});

export default styles;
